export enum SignatureSize {
  Big = 'big',
  Small = 'small',
}
